module.exports = __webpack_public_path__ + "static/404-cfd0bfdc10ecd28a90cfa2f8c6861114.svg";